export default {"src":"/_next/static/media/arrow-down.a1c18eac.svg","height":513,"width":513};